import builder from '../builder';
import AccountingCoinsStack from '../../streamline-icons/light/accounting-coins-stack.svg';

export default builder('IconAccountingCoinsStackLight', AccountingCoinsStack);
